import { FEATURE_TOGGLES } from '../../constants';

export type FeatureTogglesSlice = Record<string, boolean>;

export const getFeatureTogglesInitialState = (): FeatureTogglesSlice => ({
  [FEATURE_TOGGLES.DISABLE_AI_SERVICES]: false,
});
